/* src/app/payroll/employee-payroll-item/employee-base-rate-presenter/employee-base-rate-presenter.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
:host ::ng-deep .p-datatable {
  flex: 1 1 auto;
  min-height: 0;
}
:host ::ng-deep .p-datatable-wrapper {
  flex: 1 1 auto;
  min-height: 0;
}
:host ::ng-deep .edit-cell {
  width: 3rem;
  text-align: center;
}
:host ::ng-deep .p-datatable-cell.disabled {
  color: var(--p-text-muted-color, #6b7280);
}
/*# sourceMappingURL=employee-base-rate-presenter.component.css.map */
